import { oz } from '@weft/utils';

export const HomePageInvoiceSummaryComparisonsSchema = oz.object({
  totalInvoicesSum: oz.number(),
  lastMonthInvoicesSum: oz.number(),
  totalActiveCustomers: oz.number(),
  lastMonthActiveCustomers: oz.number(),
  totalActiveContracts: oz.number(),
  lastMonthActiveContracts: oz.number(),
}).openapi('HomePageInvoiceSummaryComparisons');

export type HomePageInvoiceSummaryComparisons = oz.infer<typeof HomePageInvoiceSummaryComparisonsSchema>;